import { createTheme } from "@material-ui/core/styles";

export const temaFormulario = createTheme({  
  palette: {
    primary: {
      main: "#D4BFF9",
      contrastText: "rgba(66, 66, 66, 1)",
    },
    secondary: {
      main: "rgba(66, 66, 66, 1)",
      contrastText: "#fff",
    }
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: "4px 8px",
        backgroundColor: "#eaeaea",
      },
    },
    MuiCardHeader: {
      title: {
        fontSize: 18,
      },
    },
  },
});

export default temaFormulario;
